// extracted by mini-css-extract-plugin
export default {"textFieldWrapper":"PasswordField_textFieldWrapper__T5ibH","inputClickArea":"PasswordField_inputClickArea__Crao6"};